import { render } from "./Managements.vue?vue&type=template&id=fa6434a4&scoped=true"
import script from "./Managements.vue?vue&type=script&lang=js"
export * from "./Managements.vue?vue&type=script&lang=js"

import "./Managements.vue?vue&type=style&index=0&id=fa6434a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa6434a4"]])

export default __exports__